import React, { FC } from 'react';
import styled from 'styled-components';

interface InputProps {
  accept?: string;
  onChange: (file: File) => void;
  disabled?: boolean;
}

const Input = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
`;

const Label = styled.label`
  position: relative;
  width: 100%;
  height: 100%;
  display: block;
`;

export const FileInput: FC<InputProps> = ({
  onChange,
  children,
  accept,
  disabled
}) => {
  return (
    <Label>
      {children}
      <Input
        accept={accept}
        disabled={disabled}
        type="file"
        onChange={({ target: { files } }) =>
          files && files[0] ? onChange(files[0]) : null
        }
      />
    </Label>
  );
};
